/* Bloqueo de scroll de fondo en móvil — Recambios y Accesorios BMW
   ---------------------------------------------------------------------------
   PROBLEMA: al abrir el carrito flotante, el theme pone `overflow: hidden`
   en el <body>. En Safari de iPhone eso NO bloquea el scroll, porque quien
   scrollea es el elemento raíz. Resultado: arrastrando por la franja de
   página que queda a la vista, el fondo se movía y el panel quedaba
   descolocado.

   SOLUCIÓN: mientras hay un panel abierto, fijamos el body con
   `position: fixed` conservando la posición exacta, y al cerrar la
   devolvemos. Es la única forma fiable en iOS.

   Solo actúa en pantallas táctiles pequeñas: en escritorio `overflow:hidden`
   ya funciona y no hace falta tocar nada.

   PARA QUITARLO: borra la línea que carga este fichero en layout/theme.liquid.
   No depende del interruptor de Express ni de ningún otro ajuste. */
(function () {
  'use strict';

  // Clases que el sitio usa para decir "hay un panel abierto encima"
  var MARCAS = ['overflow-hidden', 'express-modal-abierto'];

  var bloqueado = false;
  var scrollGuardado = 0;

  // Ancla de posición. No sirve leer window.pageYOffset en el momento de
  // bloquear: el tema mueve el foco al abrir el panel y ese focus() ya ha
  // llevado la página a 0. Por eso guardamos la posición en el gesto del
  // usuario (el dedo o el clic que abre el panel), que siempre ocurre antes.
  var anclaScroll = 0;
  function recordarPosicion() {
    if (!bloqueado) anclaScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
  }
  ['pointerdown', 'touchstart', 'mousedown', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, recordarPosicion, { capture: true, passive: true });
  });

  function esMovil() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function hayPanelAbierto() {
    for (var i = 0; i < MARCAS.length; i++) {
      if (document.body.classList.contains(MARCAS[i])) return true;
    }
    // el modal de Express usa estilo en línea, no clase
    return document.body.style.overflow === 'hidden';
  }

  function bloquear() {
    if (bloqueado || !esMovil()) return;
    scrollGuardado = window.pageYOffset || document.documentElement.scrollTop || 0;
    // Si el foco ya nos ha llevado arriba, vale el ancla del gesto.
    if (scrollGuardado === 0 && anclaScroll > 0) scrollGuardado = anclaScroll;
    var b = document.body;
    b.dataset.scrollLock = String(scrollGuardado);
    b.style.position = 'fixed';
    b.style.top = '-' + scrollGuardado + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    bloqueado = true;
  }

  function desbloquear() {
    if (!bloqueado) return;
    var b = document.body;
    var y = parseInt(b.dataset.scrollLock || '0', 10);
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    delete b.dataset.scrollLock;
    bloqueado = false;
    // Volver exactamente donde estaba, sin animación.
    window.scrollTo(0, isNaN(y) ? 0 : y);
  }

  function revisar() {
    if (hayPanelAbierto()) { bloquear(); } else { desbloquear(); }
  }

  // Observamos SOLO los atributos del body. No tocamos class ni nodos hijos,
  // así que el observador no puede dispararse con sus propios cambios.
  var obs = new MutationObserver(function () {
    // Si estamos bloqueados, nuestro propio style.position='fixed' hace que
    // hayPanelAbierto() siga siendo cierto por la vía del overflow; por eso
    // comprobamos las clases primero y el estilo solo como respaldo.
    revisar();
  });

  function init() {
    if (!document.body) return;
    obs.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    revisar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Si el usuario gira el móvil o pasa a escritorio, soltamos el bloqueo.
  window.addEventListener('resize', function () {
    if (bloqueado && !esMovil()) desbloquear();
  });

  // RED DE SEGURIDAD. Si por lo que sea el body se quedase fijado sin ningún
  // panel abierto, la web quedaría inutilizable. Estos dos eventos cubren los
  // casos reales en que eso podría pasar: volver con el botón atrás (bfcache)
  // y regresar a la pestaña.
  window.addEventListener('pageshow', function () {
    if (bloqueado && !hayPanelAbierto()) desbloquear();
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && bloqueado && !hayPanelAbierto()) desbloquear();
  });
})();
